{
  "feedback-process-pages": {
    "feedback-process-steps": {
      "step-1": {
        "title": "Vaše spokojenost",
        "description": "Jste spokojeni s našimi službami"
      },
      "step-2": {
        "title": "Vaše zpětná vazba",
        "description": "Napište svůj názor"
      },
      "step-3": {
        "title": "Odeslaná zpětná vazba",
        "description": "Vaše zpětná vazba je odeslána"
      }
    },
    "meta": {
      "title": "Zpětná vazba",
      "description": "Vaše zpětná vazba"
    }
  }
}
